import React, { Component } from 'react';
import ScrollUpButton from "react-scroll-up-button";


class Footer extends Component {
    render() {
        return (
            <React.Fragment>
                <footer className="footer fixed-footer" style={{padding:1}}>
                    <p className="fuente-monserrat">
                        &copy; {new Date().getFullYear()} Instituto Universitario de Diseño Las Mercedes | RIF J-30583313-3

                        <p className="copyright fuente-monserrat" style={{marginTop:1, padding: 0, color:"FFF"}}>
                            Diseñado y Desarrollado por <a href = "https://www.eyss.io/">
                            <span style = {{color:"#4885ed"}}>E</span>
                            <span style = {{color:"#dc3d36"}}>Y</span>
                            <span style = {{color:"#f4c230"}}>S</span>
                            <span style = {{color:"#62bc55"}}>S</span>
                            </a>
                        </p>
                    </p>
                    <div>
                        <ScrollUpButton
                            EasingType="easeInOutQuad"
                            ShowAtPosition={100}
                            ContainerClassName="ir-arriba" 
                            TransitionClassName='ScrollUpButton__Toggled'
                            style={{background : "#a80012"}}
                        />
                    </div>
                </footer>
            </React.Fragment>
            
        );
    }
}

export default Footer;




// WEBPACK FOOTER //
// ./src/site/Componentes/Index/Footer.jsx